import { SetLoader } from '../../redux/actions/loader'
import { POST, GET } from '../API'
import { store } from '../../redux/store'

const { dispatch } = store

// http://localhost:9999/spectro/templates?product=cold
const CreateTemplate = async (
  productName,
  assetData,
  customerID,
  templateConf,
  action,
) => {
  dispatch(SetLoader(true))
  console.log('templateConf', templateConf)
  const queryParams = {
    product: productName,
    action,
  }
  let body = {}
  if (action === 'create') {
    body = {
      'template name': templateConf.templateName,
      'customer id': customerID,
      'asset id': assetData.id,
      'asset type': vehicleEnum[assetData.assetType] || assetData.assetType,
      'asset thresholds': {
        'door left open': templateConf.doorLeftOpen,
        'door open neglect': templateConf.doorOpenNeglectThreshold || 10,
        'warning high temperature':
          templateConf.warningHighTemperatureThreshold ||
          (assetData['asset type'] === 'ROOM' ? 22 : 6),
        'warning low temperature':
          templateConf.warningLowTemperatureThreshold ||
          (assetData['asset type'] === 'ROOM' ? 15 : 3),
        'critical high temperature':
          templateConf.criticalHighTemperatureThreshold ||
          (assetData['asset type'] === 'ROOM' ? 25 : 7),
        'critical low temperature':
          templateConf.criticalLowTemperatureThreshold ||
          (assetData['asset type'] === 'ROOM' ? 12 : 2),
        'warning humidity':
          templateConf.warningHumidityThreshold ||
          (assetData['asset type'] === 'ROOM' ? 50 : 65),
        'critical humidity':
          templateConf.criticalHumidityThreshold ||
          (assetData['asset type'] === 'ROOM' ? 65 : 80),
        'low light': templateConf.lowLightThreshold,
        'Unauthorized movement': templateConf.unauthorizedMovementThreshold,
        'out of location': templateConf.outOfLocationThreshold,
        'compressor temperature':
          templateConf.compressorTemperatureThreshold ||
          (assetData['asset type'] === 'Full-Fledge Fridge' ? 55 : null),
        'compressor vibration':
          templateConf.compressorVibrationThreshold ||
          (assetData['asset type'] === 'Full-Fledge Fridge' ? 4500 : null),
        power: templateConf.powerThreshold,
        'idle asset threshold': templateConf.idleAssetThreshold || 60,
        'device inactive threshold': templateConf.deviceInactiveThreshold || 60,
        'hw door open count': templateConf.doorOpenCountTimeSampling,
        voltage: templateConf.voltage,
      },
    }
  }
  if (action === 'assign') {
    console.log('assetDataaaa2', assetData)
    body = {
      'template name': templateConf,
      'customer id': customerID,
      'asset id': assetData['asset id'],
      'asset type':
        vehicleEnum[assetData['asset type']] || assetData['asset type'],
    }
  }
  const response = await POST(`/spectro/templates`, queryParams, body)
  dispatch(SetLoader(false))

  return response
}
// assign template to asset
const AssignTemplateToAsset = async (
  userEmail,
  productName,
  asset,
  templateName,
) => {
  dispatch(SetLoader(true))

  const queryParams = {
    product: productName,
  }
  const body = {
    'device id': asset.id,
    email: userEmail,
  }

  const response = await POST(
    `/spectro/templates/${templateName}/assets/${asset.name}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))

  return response
}

const AssignTemplateToDevice = async (
  userEmail,
  productName,
  device,
  templateName,
) => {
  dispatch(SetLoader(true))

  const queryParams = {
    product: productName,
  }
  const body = {
    'device id': device.id,
    email: userEmail,
  }

  const response = await POST(
    `/spectro/templates/${templateName}/devices/${device.name}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))

  return response
}
const assetsEnum = {
  Room: 'ROOM',
  'Indoor Fridge': 'INDOOR',
  'Outdoor Fridge': 'OUTDOOR',
  'Full-Fledge Fridge': 'FULL_FLEDGE',
  'Trackable Vehicle': 'VEHICLE',
  'Non-Trackable Vehicle': 'VEHICLE_FRIDGE',
  'Vehicle Sfda': 'VEHICLE_SFDA',
  General: 'GENERAL',
}

// spectro/assets/bulk?
// product=cold&customerId= ss&tenantId= &fromId=f59h&assetType=Room&code=spectro-cold-room
const UploadCreationFile = async (
  productName,
  assetType,
  facility,
  file,
  customerId,
  tenantId,
  code,
) => {
  console.log('customerId', customerId)
  dispatch(SetLoader(true))
  const formData = new FormData()

  formData.append('file', file)

  const queryParams = {
    product: productName,
    customerId,
    tenantId,
    fromId: facility,
    assetType,
    code,
  }

  const headers = {
    'Content-Type': 'multipart/form-data',
  }
  const response = await POST(
    `/spectro/assets/bulk`,
    queryParams,
    formData,
    headers,
  )
  dispatch(SetLoader(false))

  return response
}

// valid: http://localhost:9999/spectro/devices/aa@spectro.net/upload?product=cold&device=spectro-cold&customerId=d8b2cb30-261b-11ea-8b2b-fb0a93577e8f
// invalid: http://192.168.30.59:3000/spectro/assets/bulk?product=admin%40spectro.net&customerId=d8b2cb30-261b-11ea-8b2b-fb0a93577e8f&fromId=spectro-cold&assetType=cold
const UploadColdCreationFile = async (
  userEmail,
  productName,
  customerId,
  device,
  file,
) => {
  console.log('customerId', customerId)
  dispatch(SetLoader(true))
  const formData = new FormData()

  formData.append('file', file)

  const queryParams = {
    product: productName,
    customerId,
    device,
  }

  const headers = {
    'Content-Type': 'multipart/form-data',
  }
  const response = await POST(
    `/spectro/devices/${userEmail}/upload`,
    queryParams,
    formData,
    headers,
  )
  dispatch(SetLoader(false))

  return response
}

const UploadTankCreationFile = async (
  userEmail,
  productName,
  device,
  file,
  customerId,
) => {
  console.log('customerId', customerId)
  dispatch(SetLoader(true))
  const formData = new FormData()

  formData.append('file', file)

  const queryParams = {
    product: productName,
    device,
    customerId,
  }

  const headers = {
    'Content-Type': 'multipart/form-data',
  }
  const response = await POST(
    `/spectro/devices/${userEmail}/upload`,
    queryParams,
    formData,
    headers,
  )
  dispatch(SetLoader(false))

  return response
}

const uploadAssetFile = async (queryParams, file) => {
  const formData = new FormData()
  formData.append('file', file)
  const headers = {
    'Content-Type': 'multipart/form-data',
  }
  dispatch(SetLoader(true))
  const response = await POST(
    '/spectro/assets/bulk',
    queryParams,
    formData,
    headers,
  )
  dispatch(SetLoader(false))
  return response
}
//  spectro/templates/customers/d8b2cb30-261b-11ea-8b2b-fb0a93577e8f/assets/ROOM?product=cold
const GetUserTemplates = async (productName, customerID, assetType) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))
  const asset = vehicleEnum[assetType] || assetType
  console.log('prrrr', productName, customerID, assetType)

  const response = await GET(
    `/spectro/templates/customers/${customerID}/assets/${asset}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const GetCustomerTemplates = async (queryParams) => {
  const res = await GET('/spectro/templates/customer', queryParams)
  return res
}

export const vehicleEnum = {
  Room: 'ROOM',
  'Indoor Fridge': 'INDOOR',
  'Outdoor Fridge': 'OUTDOOR',
  'Full-Fledge Fridge': 'FULL_FLEDGE',
  Vehicle: 'VEHICLE',
  'Vehicle Fridge': 'VEHICLE_FRIDGE',
}
// http://localhost:3000/spectro/assets/templates/ROOM/customer/partner@spectro.net/?product=cold
const GetConfigTemplate = async (productName, email, assetType) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))
  console.log('assetType', assetType)
  const assetCategory = vehicleEnum[assetType] || assetType
  const response = await GET(
    `/spectro/assets/templates/${assetCategory}/customer/${email}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}
// localhost:9999/spectro/storages?product=cold
const GetsfdaStorageTypes = async (productName) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/storages/`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

const GetCreationTemplate = async (productName, deviceType) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/load-creation/${deviceType}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

const GetTankCreationTemplate = async (productName) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/load-creation/spectro-tank/`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

const GetAssetCreationTemplate = async (productName, assetType, userEmail) => {
  const queryParams = {
    product: 'cold',
  }
  const asset = assetsEnum[assetType] || assetType
  console.log('assetType', assetType)
  dispatch(SetLoader(true))
  // spectro/assets/Vehicle/customer/aa@spectro.net?product=cold
  const response = await GET(
    `/spectro/assets/templates/${asset}/customer/${userEmail}/`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

const UpdateTemplate = async (body, queryParams) => {
  const res = await POST('/spectro/templates/update', queryParams, body)
  return res
}

export {
  CreateTemplate,
  AssignTemplateToDevice,
  AssignTemplateToAsset,
  GetUserTemplates,
  GetConfigTemplate,
  GetCreationTemplate,
  GetAssetCreationTemplate,
  UploadCreationFile,
  GetsfdaStorageTypes,
  GetTankCreationTemplate,
  uploadAssetFile,
  UploadTankCreationFile,
  GetCustomerTemplates,
  UpdateTemplate,
  UploadColdCreationFile,
}
